/**
 * 地球全览深空氛围（与 Mapbox 球体黑底一致）
 * 供栅格底图（高德/谷歌/天地图等）在 globe 态使用
 *
 * 注意：切 setStyle 期间不要 setFog / jumpTo，否则 Mapbox
 * fog.getOpacityAtLatLng 会因 state 未就绪崩溃。
 */

import { isEarthSpinRenderPaused } from './earthSpinGate';

/** 深空背景色（CSS / style background-color） */
export const EARTH_SPACE_BG = '#060c1a';

/** Mapbox fog：薄大气 + 黑色深空 + 星点 */
export const EARTH_DEEP_SPACE_FOG = {
  color: 'rgb(55, 95, 145)',
  'high-color': 'rgb(90, 150, 225)',
  'horizon-blend': 0.02,
  'space-color': 'rgb(6, 12, 26)',
  'star-intensity': 0.55
};

/** 仅改容器/背景层颜色（不含 fog，切样式时安全） */
export function applyEarthSpaceBackground(map) {
  if (!map) return false;
  try {
    const container = map.getContainer?.();
    if (container) container.style.background = EARTH_SPACE_BG;
  } catch (_) {
    /* ignore */
  }
  try {
    if (map.getLayer?.('background')) {
      map.setPaintProperty('background', 'background-color', EARTH_SPACE_BG);
    }
  } catch (_) {
    /* ignore */
  }
  return true;
}

/**
 * 应用深空背景 + fog
 * @param {{ allowDuringPause?: boolean }} options
 */
export function applyEarthDeepSpaceLook(map, options = {}) {
  if (!map) return false;
  if (!options.allowDuringPause && isEarthSpinRenderPaused()) return false;
  try {
    if (typeof map.isStyleLoaded === 'function' && !map.isStyleLoaded()) return false;
  } catch (_) {
    return false;
  }

  applyEarthSpaceBackground(map);

  try {
    if (typeof map.setFog === 'function') {
      map.setFog(EARTH_DEEP_SPACE_FOG);
    }
  } catch (_) {
    /* ignore */
  }

  return true;
}

/**
 * 样式切换后等 idle（或超时）再执行，避免 fog.state 未就绪
 */
export function whenMapStyleSettled(map, callback, timeoutMs = 1500) {
  if (!map || typeof callback !== 'function') return () => {};
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    try {
      map.off?.('idle', onIdle);
    } catch (_) {
      /* ignore */
    }
    // idle 后再空两帧，给 fog 内部 state 收尾时间
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        try {
          callback();
        } catch (e) {
          console.warn('whenMapStyleSettled 回调失败:', e);
        }
      });
    });
  };
  const onIdle = () => run();
  const timer = setTimeout(run, timeoutMs);
  try {
    map.once('idle', onIdle);
  } catch (_) {
    /* ignore */
  }
  return () => {
    done = true;
    clearTimeout(timer);
    try {
      map.off?.('idle', onIdle);
    } catch (_) {
      /* ignore */
    }
  };
}
